module.exports = __webpack_public_path__ + "static/media/punaisten-poimintaa.4a958a61.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./media/photos/punaisten-poimintaa.jpg
 ** module id = 385
 ** module chunks = 0
 **/